// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03fcf1d5","453":"7e4838f3","732":"982a2e39"}[chunkId] + ".chunk.js";
};